import { render, staticRenderFns } from "./Affiliator.vue?vue&type=template&id=542b02bc&scoped=true"
import script from "./Affiliator.vue?vue&type=script&lang=js"
export * from "./Affiliator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b02bc",
  null
  
)

export default component.exports